import { JsonSchema, JsonSchema7 } from '@jsonforms/core';
import { extractRequiredPaths } from '../utils/extractRequiredPaths';
import { generateDefaultFormData } from '../utils/generateFormData';
import { resolveJSONSchema } from '../utils/resolveSchema';
import schema from '@/app/schema/schema.json';

export const originSchema: JsonSchema7 = resolveJSONSchema(schema);
export const defaultFormData = generateDefaultFormData(originSchema);
export const { requiredPaths, oneOfPaths, oneOfOptionsPaths } = extractRequiredPaths(originSchema);
export const topLevelElements = Object.entries(originSchema.properties ?? {})
  .map(([name, value]) => ({
    name,
    description: value?.description ?? '',
    label: value?.title ?? '',
    //@ts-ignore:next-line
    settingid: value?.settingid ?? '',
  }))
  .filter((element) => element.settingid !== 'processorSchemaVersion');

export function getSubschema(schema: JsonSchema, path: string): JsonSchema {
  // Split the path into parts using '.' as the separator
  const pathParts = path.split('.');

  // Start with the top-level schema
  let current = schema;

  // Iterate through each part of the path
  for (const part of pathParts) {
    // Check if 'properties' exists and contains the current part
    if (current.properties && current.properties[part]) {
      current = current.properties[part];
    } else {
      throw new Error(`Path not found: ${path}`);
    }
  }

  // Return the subschema at the end of the path
  return current;
}
